export const VIDEO_TYPE = {
    CURRENT: 'current',
    COMPARISON: 'comparison',
} as const;

export type VideoTypeByOrigin = (typeof VIDEO_TYPE)[keyof typeof VIDEO_TYPE];
